<div class="container-fluid mt-4">
  <div class="p-1">
 
    <app-upload (uploadComplete)="onUploadComplete()"  [uploadPath]="currentFolderPath"></app-upload>

  </div>

  <div class="alert alert-secondary mb-3 mt-3">
    <strong>მიმდინარე გზა:</strong> {{ currentFolderPath }}
  </div>


  <div class="d-flex">
    <div *ngIf="pathStack.length > 0">
      <button  (click)="goBack()" class="btn btn-default mb-2">
        <i class="fi fi-rr-left"></i> უკან დაბრუნება
      </button>
    </div>

    <div >
      <app-folder-create
          [currentPath]="currentFolderPath"
          (folderCreated)="onUploadComplete()">
      </app-folder-create>
    </div>
  </div>
  
  <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

  <div class="file-grid" >
    <div *ngFor="let item of fileTree" class="file-item position-relative">
      
      <span (click)="delete(item)" class="delete position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"><i class="fi fi-rr-trash"></i></span>

      <div (click)="openFolder(item)" *ngIf="item.type === 'folder'">
        <img src="assets/images/folder.webp" />
         <div class="name">{{ item.name }}</div>
      </div>

      <div *ngIf="item.type === 'file'" class="file">
        
        <img
          *ngIf="isImageFile(item.name)"
          [src]="item.url"
          alt="{{ item.name }}"
          (click)="multiselect ? selectMultipleFile(item.url) : selectFile(item.url)"
          [class.selected]="selectedFiles.includes(item.url)" />
        
        <span *ngIf="!isImageFile(item.name)">
          <img src="assets/images/document.png" (click)="selectFile(item.url)"/>
        </span>

        <div class="name">{{ item.name }}</div>
      </div>

    </div>

  </div>
</div>